import { useState } from 'react';
import { Bot } from 'lucide-react';
import PageContainer from '../../components/ui/PageContainer';
import PageHeader from '../../components/ui/PageHeader';
import ChatbotConfigTab from './ChatbotConfigTab';
import ChatbotConversationsTab from './ChatbotConversationsTab';
import ChatbotTabs from './ChatbotTabs';
import ChatbotUsageTab from './ChatbotUsageTab';
import type { ChatbotTab } from './chatbotShared';

export default function ChatbotPage() {
  const [tab, setTab] = useState<ChatbotTab>('config');

  return (
    <PageContainer>
      <PageHeader
        icon={<Bot size={22} />}
        title="Asistente del sitio"
        description="Un asistente que saluda a tus visitantes y responde sus dudas usando solo la información de tu negocio."
      />

      <ChatbotTabs tab={tab} onChange={setTab} />

      {tab === 'config' && <ChatbotConfigTab />}
      {tab === 'usage' && <ChatbotUsageTab />}
      {tab === 'conversations' && <ChatbotConversationsTab />}
    </PageContainer>
  );
}
